import * as React from "react"

import { cn } from "@/lib/utils"

type NullableInputProps =
  Omit<React.ComponentProps<"input">, "value"> & {
    value?: string | number | readonly string[] | null;
  };

const Input = React.forwardRef<HTMLInputElement, NullableInputProps>(
  ({ className, type,value, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-8 w-full rounded-xs border border-input dark:border-zinc-400 bg-transparent dark:bg-zinc-600 dark:color-zinc-200 px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground dark:placeholder:text-zinc-200 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",className
        )}
        ref={ref}
        value={value??undefined}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
